import type { BifrostWeb } from '@seekrtech/bifrost-web'
import type { Result } from '../types'

/** The arm native assigned for one experiment (a native experiment group). */
export interface ExperimentGroup {
  experiment: string
  /** Arm name as native spells it, e.g. `Control` / `Variant1`. */
  group: string
  /** Numeric arm value, native's key for config and analytics. */
  raw_value: number
}

export type ExperimentServiceError =
  /** This app version has no such experiment registered. */
  | 'not_registered'
  /** `experiment` is empty or malformed. */
  | 'invalid_request'
  /** The user is outside this experiment's audience. */
  | 'not_eligible'

export interface ExperimentServiceMethods {
  getGroup: (payload: {
    experiment: string
  }) => Promise<Result<ExperimentGroup, ExperimentServiceError>>
}

export function createExperimentService(
  bifrost: BifrostWeb,
): ExperimentServiceMethods {
  return bifrost.createNativeProxy<ExperimentServiceMethods>(
    'ExperimentService',
  )
}
